import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Input, Modal, Alert } from 'antd'
import ConfirmButton from '@components/ConfirmButton'
import { groupPolicyProviders } from '@services/api'

import ProviderPolicies from './ProviderPolicies'
import ProviderUsers from './ProviderUsers'

import * as styles from './styles.scss'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class CompanyPopup extends Component<any, any> {
    state = {
        policiesActions: null
    }

    closePopup = () => {
        this.setState({ policiesActions: null })
        this.props.popupStore.togglePopup(false)
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    deleteProvider = async () => {
        const { relatedPolicies, relatedUsers, id } = this.props.popupStore.info
        if (relatedPolicies.length > 0) {
            this.setError('deleteError', 'לא ניתן למחוק מעסיק אליו משוייכות פוליסות')
        } else if (relatedUsers.length > 0) {
            this.setError('deleteError', 'לא ניתן למחוק מעסיק אשר משוייך למשתמשים')
        } else {
            try {
                await groupPolicyProviders.deleteProvider(id)
                this.props.popupUpdated()
                this.closePopup()
            } catch (e) {
                this.setError('serverErrors', [{ message: 'בעיה בחיבור לשרת' }])
            }
        }
    }

    validateProvider = () => {
        const { name } = this.props.popupStore.info
        if (!name) {
            return this.setError('nameError', 'אנא הזן שם מעסיק')
        } else {
            this.setError('nameError', null)
        }
        return true
    }

    saveProvider = async () => {
        const { popupType, info } = this.props.popupStore
        if (this.validateProvider()) {
            try {
                if (popupType === 'addProvider') {
                    await groupPolicyProviders.addProvider(info)
                } else if (popupType === 'editProvider') {
                    await groupPolicyProviders.updateProvider(info)
                }
                this.props.popupUpdated()
                this.closePopup()
            } catch (e) {
                if (e.response.status === 400) {
                    this.setError('serverErrors', e.response.data)
                } else {
                    this.setError('serverErrors', [{ message: 'בעיה בחיבור לשרת' }])
                }
                console.error(e.response)
            }
        }
    }

    setValue = (e, name) => {
        this.props.popupStore.editInfo(name, e)
    }

    render() {
        const { popupStore, authStore } = this.props
        const { policiesActions } = this.state
        const { name, relatedPolicies, relatedUsers, id } = popupStore.info
        const { nameError, serverErrors, deleteError } = popupStore.errors

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <div style={{ float: 'left', display: 'inline-block' }}>
                    {popupStore.popupType === 'editProvider' && authStore.roles[0] === 'admin' ? (
                        <ConfirmButton
                            confirmed={() => this.deleteProvider()}
                            confirmQuestion="למחור מעסיק?"
                            buttonText="מחק מעסיק"
                        />
                    ) : null}
                </div>
                <Button onClick={this.closePopup}>ביטול</Button>
                <Button type="primary" onClick={this.saveProvider}>
                    {popupStore.popupType === 'addProvider' ? 'הוסף' : 'שמור'}
                </Button>
            </div>
        )
        return (
            <Modal
                title={popupStore.popupType === 'addProvider' ? 'הוספת מעסיק' : 'עריכת פרטי מעסיק'}
                visible={popupStore.popupType === 'addProvider' || popupStore.popupType === 'editProvider'}
                onCancel={this.closePopup}
                okText={popupStore.popupType === 'addProvider' ? 'הוסף' : 'שמור'}
                cancelText="ביטול"
                footer={footerButtons}
            >
                {serverErrors ? <span className={styles.server_error}>{serverErrors[0].message}</span> : ''}
                <Input
                    placeholder="שם המעסיק"
                    value={name}
                    autoComplete="off"
                    name="name"
                    onChange={e => this.setValue(e.target.value, 'name')}
                />
                {nameError ? <span className={styles.error}>{nameError}</span> : ''}
                <div>
                    <ProviderPolicies
                        relatedPolicies={relatedPolicies}
                        policiesActions={policiesActions}
                        id={id}
                        updatePoliciesActions={status => this.setState({ policiesActions: status })}
                    />
                </div>
                <div style={{ marginTop: '0.5rem' }}>
                    <ProviderUsers relatedUsers={relatedUsers} />
                </div>
                <div style={{ marginTop: '0.5rem' }}>
                    {deleteError ? <Alert message={deleteError} type="error" /> : ''}
                </div>
            </Modal>
        )
    }
}
